// Les trois icônes ci-dessous sont des `kind` d'`IdfIcon` (ui-kit). Elles remplacent les noms
// de la police d'icônes de @b2ag/design-system (`category-pick-up-point`, `category-delivery`,
// `category-cooperative`), qui n'ont pas d'équivalent nominal côté ui-kit.
export const SHIPPING_PICKUP_POINT = 'pickup_point'
export const SHIPPING_PICKUP_POINT_TITLE = 'Relais'
export const SHIPPING_PICKUP_POINT_ICON = 'location-filled'
export const SHIPPING_FARM = 'farm'
export const SHIPPING_FARM_TITLE = 'Livraison à la ferme'
export const SHIPPING_FARM_ICON = 'truck-filled'
export const SHIPPING_CLICK_AND_COLLECT = 'click_and_collect'
export const SHIPPING_CLICK_AND_COLLECT_TITLE = 'Retrait magasin'
export const SHIPPING_CLICK_AND_COLLECT_ICON = 'store-filled'

export const SHIPPING_WITH_CONTACT = [SHIPPING_FARM, SHIPPING_PICKUP_POINT]

export const defaultShippingWays = (i18n) => [
  {
    title: `${SHIPPING_PICKUP_POINT_TITLE} ${i18n.t('message.partner')}`,
    kind: SHIPPING_PICKUP_POINT,
  },
  {
    title: SHIPPING_FARM_TITLE,
    kind: SHIPPING_FARM,
  },
  {
    title: SHIPPING_CLICK_AND_COLLECT_TITLE,
    kind: SHIPPING_CLICK_AND_COLLECT,
  },
]

export const SHIPPING_ICONS = {
  [SHIPPING_FARM]: SHIPPING_FARM_ICON,
  [SHIPPING_CLICK_AND_COLLECT]: SHIPPING_CLICK_AND_COLLECT_ICON,
  [SHIPPING_PICKUP_POINT]: SHIPPING_PICKUP_POINT_ICON,
}

export const SHIPPING_TITLES = {
  [SHIPPING_FARM]: SHIPPING_FARM_TITLE,
  [SHIPPING_CLICK_AND_COLLECT]: SHIPPING_CLICK_AND_COLLECT_TITLE,
  [SHIPPING_PICKUP_POINT]: SHIPPING_PICKUP_POINT_TITLE,
}
